var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTextColor = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 19.5C0 19.0858 0.335786 18.75 0.75 18.75H23.25C23.6642 18.75 24 19.0858 24 19.5V22.5C24 22.9142 23.6642 23.25 23.25 23.25H0.75C0.335786 23.25 0 22.9142 0 22.5V19.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.46889 15.8959C7.33388 16.2591 6.9873 16.5 6.59986 16.5V16.5C5.94923 16.5 5.50097 15.8474 5.7345 15.2401L10.6658 2.4164C10.8781 1.86431 11.4085 1.5 12 1.5V1.5C12.5915 1.5 13.1219 1.86431 13.3342 2.4164L18.2655 15.2401C18.499 15.8474 18.0508 16.5 17.4001 16.5V16.5C17.0127 16.5 16.6661 16.2591 16.5311 15.8959L12.0827 3.93056C12.0699 3.89599 12.0369 3.87305 12 3.87305V3.87305C11.9631 3.87305 11.9301 3.89599 11.9173 3.93056L7.46889 15.8959ZM7.98068 11.4463C7.98068 11.0013 8.34139 10.6406 8.78635 10.6406H15.2137C15.6586 10.6406 16.0193 11.0013 16.0193 11.4463V11.4463C16.0193 11.8912 15.6586 12.252 15.2137 12.252H8.78635C8.34139 12.252 7.98068 11.8912 7.98068 11.4463V11.4463Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text-color.815bdef02796174699ae0c3e5999aec6.svg";